<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="lg-fix-h" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" :disabled="isGeneralLoading"/>
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 45vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
        >
          <div class="lg:mb-2">
            <div ref="AsuntoCorreo">
              <div class="flex items-center mb-1">
                <span id="input-text-mail-vinculados-asunto-label" class="text-sm font-semibold text-secondary-600 block">{{$t('app.AsuntoCorreo')}}</span>                
              </div>
                <el-form-item prop="AsuntoCorreo">
                  <el-input
                      class="w-full"
                      v-model="form.AsuntoCorreo"
                      maxlength='255'
                      aria-labelledby="input-text-mail-vinculados-asunto-label"
                    >
                    <template v-if="form.AsuntoCorreo" slot="suffix">
                      <base-clear-input-button
                        aria-label="Limpiar campo"
                        @clear="form.AsuntoCorreo = ''"
                      />
                    </template>
                  </el-input>
                </el-form-item>
            </div>
            <div ref="TextoCorreo">
              <div class="flex items-center mb-1">
                <span id="input-text-mail-vinculados-texto-label" class="text-sm font-semibold text-secondary-600 block">{{$t('app.TextoCorreo')}}</span>
                <base-tooltip-icon size="sm" :section="$t('app.TextoCorreo')" :content="$t('tooltip.texto_correo')" class="ml-2"/>
              </div>
                <el-form-item prop="TextoCorreo">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="w-full"
                    aria-labelledby="input-text-mail-vinculados-texto-label"
                    v-model="form.TextoCorreo"
                    maxlength="1000"
                    >
                    <template v-if="form.TextoCorreo" slot="suffix">
                      <base-clear-input-button
                        aria-label="Limpiar campo del texto del correo"
                        @clear="form.TextoCorreo = ''"
                      />
                    </template>
                  </el-input>
                </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply()" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'

export default
{
  name: 'input-text-mail-vinculados-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        TextoCorreo: '',
        AsuntoCorreo: '',
      }      
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.TextoCorreo = ''
      this.form.AsuntoCorreo = ''
    }
  },
  mounted: async function () {
  },
  computed: {        
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    }    
  },
  methods: {
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function () {      
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form)
    }
  }
}
</script>
